module.exports = __webpack_public_path__ + "static/media/carousel4.eca19e47.jpg";